export default __webpack_public_path__ + "static/media/i168hp.20d580d9.webp";